import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const CM_TIMELINE_VIEW_V2_I18N_NAMESPACE =
  '@mc/next/experiments/pen-5613_v2_cm_innovative_swing'

export const i18nInstance = registerI18nResources({
  namespace: CM_TIMELINE_VIEW_V2_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
